import React, { useEffect } from 'react';
import { setPageTitle } from '../../utils/title';
import './Home.scss';
import heroImage from '../../assets/images/hero/home-page-carousel-image-1.png';
import blogPost1 from '../../assets/images/blog/blog_post_1.png';
import blogPost2 from '../../assets/images/blog/blog_post_2.jpeg';
import blogPost3 from '../../assets/images/blog/blog_post_3.png';

const Home = () => {
  useEffect(() => {
    setPageTitle('Home');
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <p className="hero__subtitle">DevOps, DevSecOps, and GRC Experts for Hire</p>
              <h1 className="hero__title">
                We Deliver Regulatory Compliance for Your Software on AWS
              </h1>
              <p className="hero__description">
                We help you build and manage a complete GRC program to keep your AI, SaaS, and data
                products secure and compliant with standards like SOC 2, HIPAA, NIST 800-171, NIST
                SP 800-53, NIST AI RMF, ISO 42001:2023, and GDPR.
                <br />
                <br />
                Our team designs and implements secure, scalable cloud infrastructure on AWS,
                combining operational excellence with a strong security posture.
                <br />
                <br />
                We help you establish or fine-tune essential administrative processes: developing
                security policies, managing vendor risk, implementing HR safeguards, centralizing
                user and device management, enforcing access controls, and conducting compliance
                testing.
                <br />
                <br />
                Throughout the audit process, we fully guide or represent you to ensure you're
                prepared and confident on your path to certification.
              </p>
              <div className="hero__buttons">
                <a href="/contact-us" className="btn btn--primary">
                  Get Started
                </a>
                <a href="/services" className="btn btn--secondary">
                  Learn More
                </a>
              </div>
            </div>
            <div className="hero__image">
              <img src={heroImage} alt="Cloud Security Posture" />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services section section--light">
        <div className="container">
          <div className="section__header section__header--center">
            <p className="section__subtitle">A Combination You Won't Find Anywhere Else</p>
            <h2 className="section__title">Our Service Offerings</h2>
            <p className="section__description">
              We sell packaged offerings for implementing cloud and AI security postures, and
              establishing and implementing the full IT Compliance (GRC) program for your business.
            </p>
          </div>

          <div className="services__grid">
            {/* Service cards */}
            <div className="card service-card">
              <h3 className="card__title">Cloud Infrastructure Design and Implementation</h3>
              <p className="card__description">
                We design robust, optimized cloud infrastructures on AWS to drive the operational
                excellence of your SaaS, Data, and AI/ML solutions.
              </p>
              <a href="/solutions/infrastructure" className="card__link">
                Read More →
              </a>
            </div>

            <div className="card service-card">
              <h3 className="card__title">Orchestration of App, AI/ML, and Data Workloads</h3>
              <p className="card__description">
                We streamline the orchestration of application and data workloads on AWS ECS and AWS
                EKS, ensuring scalability, resilience, and efficiency for your cloud-native
                solutions.
              </p>
              <a href="/solutions/ai-security" className="card__link">
                Read More →
              </a>
            </div>

            <div className="card service-card">
              <h3 className="card__title">Expert FinOps Solutions for AWS</h3>
              <p className="card__description">
                We help you achieve cost efficiency on AWS by analyzing your cloud usage,
                identifying opportunities to reduce waste, and implementing tailored strategies to
                maximize performance while minimizing expenses.
              </p>
              <a href="/solutions/finops" className="card__link">
                Read More →
              </a>
            </div>

            <div className="card service-card">
              <h3 className="card__title">Cloud Security Posture on AWS</h3>
              <p className="card__description">
                We implement strong, optimized cloud security that provides excellent protection of
                your and your customers' data, and adheres to regulatory standards.
              </p>
              <a href="/solutions/security" className="card__link">
                Read More →
              </a>
            </div>

            <div className="card service-card">
              <h3 className="card__title">Secure and Privacy-Enhanced AI Implementation</h3>
              <p className="card__description">
                We implement secure AI/ML solutions, including LLMs and custom models, deploy them
                to your cloud environment, set up robust guardrails, and establish comprehensive
                operational governance.
              </p>
              <a href="/solutions/ai-security" className="card__link">
                Read More →
              </a>
            </div>

            <div className="card service-card">
              <h3 className="card__title">IT Compliance Program Implementation</h3>
              <p className="card__description">
                We provide guidance and aid with the implementation of administrative and technical
                safeguards in your organization to ensure successful compliance certification.
              </p>
              <a href="/solutions/compliance" className="card__link">
                Read More →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Temporarily hidden Blog Section
      <section className="blog section section--light">
        <div className="container">
          <div className="section__header">
            <p className="section__subtitle">Hints and Tips on DevSecOps Topics</p>
            <h2 className="section__title">Our Blog</h2>
            <p className="section__description">
              Quickly browse our latest offers, learn more about our solutions, read our articles
              and case studies to get the full story.
            </p>
          </div>

          <div className="blog__grid">
            <div className="blog-post-card">
              <div className="blog-post-card__image">
                <img src={blogPost1} alt="Cloud Security Series #10" />
              </div>
              <div className="blog-post-card__content">
                <div className="blog-post-card__date">May 27, 2024</div>
                <h3 className="blog-post-card__title">Cloud Security Series #10</h3>
                <a href="/blog/cloud-security-series-10" className="blog-post-card__link">
                  Read More
                </a>
              </div>
            </div>

            <div className="blog-post-card">
              <div className="blog-post-card__image">
                <img src={blogPost2} alt="Cloud Security Series #9" />
              </div>
              <div className="blog-post-card__content">
                <div className="blog-post-card__date">May 27, 2024</div>
                <h3 className="blog-post-card__title">Cloud Security Series #9</h3>
                <a href="/blog/cloud-security-series-9" className="blog-post-card__link">
                  Read More
                </a>
              </div>
            </div>

            <div className="blog-post-card">
              <div className="blog-post-card__image">
                <img src={blogPost3} alt="Cloud Security Series #8" />
              </div>
              <div className="blog-post-card__content">
                <div className="blog-post-card__date">May 27, 2024</div>
                <h3 className="blog-post-card__title">Cloud Security Series #8</h3>
                <a href="/blog/cloud-security-series-8" className="blog-post-card__link">
                  Read More
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

      {/* CTA Section */}
      <section className="cta section section--light">
        <div className="container">
          <div className="cta__content">
            <h2 className="cta__title">Don't Wait To Protect Your Data</h2>
            <p className="cta__description">
              In face of evolving cybersecurity threats, everyone must act to protect their own, and
              their customers' data. Contact us now, so we can help you to keep it safe!
            </p>
            <div className="cta__buttons">
              <a href="/contact-us" className="btn btn--primary">
                Get Started
              </a>
              <a href="/services" className="btn btn--secondary">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
